// 当前页面所处环境判断(安卓环境? 苹果环境? 微信环境?)

export default class Environment {
  static isWx() {
    const ua = navigator.userAgent.toLowerCase();
    return !!ua.match(/MicroMessenger/i);
  }

  static isBrowser() {
    return !this.isWx() && !this.isApp();
  }

  static isAndroid() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf("chrome") != -1;
  }

  static isIos() {
    return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
  }

  static isApp() {
    const ua = navigator.userAgent.toLowerCase();
    return !!ua.match(/ZmBrowser/i);
  }

  static isPc() {
    return false;
  }

  static getEnv() {

    if (this.isWx()) {
      return this.env.wx;
    }

    if (this.isApp()) {
      return this.env.app;
    }

    if (this.isPc()) {
      return this.env.pc;
    }

    return this.env.brower;
  }
}

Environment.env = {
  wx: 'wx',
  app: 'app',
  pc: 'pc',
  brower: 'brower',
};
